module.exports = __webpack_public_path__ + "01dfd42ee33e76b22e99cf38d30e1a6a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/about/frig24-webfdd.png
 ** module id = 267
 ** module chunks = 0
 **/